import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c66b324"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-main-menu --fixed" }
const _hoisted_2 = { class: "oxd-main-menu-search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "oxd-main-menu-divider" }, null, -1))
const _hoisted_4 = { class: "oxd-main-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_input = _resolveComponent("oxd-input")!
  const _component_oxd_icon_button = _resolveComponent("oxd-icon-button")!
  const _component_oxd_main_menu_item = _resolveComponent("oxd-main-menu-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_oxd_icon, {
          name: "search",
          type: "svg",
          width: "22",
          height: "22",
          class: "oxd-menu-icon"
        }),
        _createVNode(_component_oxd_input, {
          modelValue: _ctx.searchTerm,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
          placeholder: _ctx.t('general.search', 'Search'),
          class: _normalizeClass({toggled: _ctx.toggle})
        }, null, 8, ["modelValue", "placeholder", "class"]),
        _createVNode(_component_oxd_icon_button, {
          onClick: _ctx.onClickCollapse,
          name: _ctx.toggle ? 'chevron-right' : 'chevron-left',
          class: "oxd-main-menu-button",
          role: "none"
        }, null, 8, ["onClick", "name"])
      ]),
      _hoisted_3
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMenuItems, (menuItem, index) => {
        return (_openBlock(), _createBlock(_component_oxd_main_menu_item, {
          key: `oxd-main-menu-${index}`,
          url: menuItem.url,
          active: menuItem.active,
          collapsed: _ctx.toggle,
          name: menuItem.name,
          icon: menuItem.icon
        }, null, 8, ["url", "active", "collapsed", "name", "icon"]))
      }), 128))
    ])
  ], 64))
}